import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import { useMemo } from 'react'
import { routes } from '../../../../../../constants/routes'
import { Link } from 'react-router-dom'

export default function useBreadcrumbItems(stampOrderNumber?: string): BreadcrumbItemType[] {
    return useMemo(() => {
        return [
            {
                key: routes.home,
                title: <Link to={routes.home}>Дашборд</Link>,
            },
            {
                key: routes.equipment,
                title: <Link to={routes.purchases}>Закупки</Link>,
            },
            {
                key: routes.equipmentStamps,
                title: <Link to={routes.purchasesStampOrders}>Заказы штампов</Link>,
            },
            {
                key: routes.purchasesStampOrder,
                title: stampOrderNumber ? `Заказ №${stampOrderNumber}` : 'Новый заказ',
            },
        ]
    }, [stampOrderNumber])
}
